/* istanbul ignore file */
import { useEffect } from 'react';
export const useEscapePress = (onPress) => {
    useEffect(() => {
        const escPress = (event) => {
            if (event.key === 'Escape') {
                onPress();
            }
        };
        document.addEventListener('keydown', escPress);
        return () => {
            document.removeEventListener('keydown', escPress);
        };
    }, [onPress]);
};
//# sourceMappingURL=use-escape-press.js.map